// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-nav .nav-item i.ms-auto {
  /*fa-arrow-down{  .nav-link .collapsed  */
  transform: rotate(0deg);
  transition: transform 0.2s linear;
}

.sidebar-nav .nav-item .selected i.ms-auto {
  /*.fa-arrow-down.open{*/
  transform: rotate(180deg);
  transition: transform 0.2s linear;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Dashboard/navItem.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,iCAAiC;AACnC","sourcesContent":[".sidebar-nav .nav-item i.ms-auto {\n  /*fa-arrow-down{  .nav-link .collapsed  */\n  transform: rotate(0deg);\n  transition: transform 0.2s linear;\n}\n\n.sidebar-nav .nav-item .selected i.ms-auto {\n  /*.fa-arrow-down.open{*/\n  transform: rotate(180deg);\n  transition: transform 0.2s linear;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
